var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_c('b-row',{staticClass:"mt-2"},[_c('b-col',{staticClass:"my-access-title mb-2",attrs:{"lg":"6","md":"12","sm":"12","xl":"6"}},[_vm._v("Manage Your Access")])],1),_vm._v(" "),_c('hr',{staticClass:"solid py-1"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }